import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Haley Halcyon
 * id 59CAC75D-7028-4672-9EC2-1B9E797BA9D1
 * name triangle-wave
 * version: 5.2.45
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/triangle-wave.svg
 * tags
 * - Audio 
 */
export const TriangleWaveIcon = createSvgIcon(<><path d="M22 12L17 22L7.1 6.04L4.24 12H2L7 2L16.9 17.96L19.76 12H22Z" /></>, 'TriangleWaveIcon');
export default TriangleWaveIcon